import Layout from './Layout/Layout'
import { RouterProvider, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import Home from './Page/Home/Home'
import Users from './Page/Users/User'
import Signin from './Page/Sinin/Signin'
import Student from './Page/Student/Student'
import Addmission from './Page/Addmission/Admission'
import Blog from './Page/blog/Blog'
import Academic from './Page/Academic/Academic'
import Facilites from './Page/Facilites/Facilites'
import MedicalFacilites from './Page/MedicalFacilities/MedicalFacilities'
import Department from './Page/Department/Departments'
import About from './Page/About/About'
import Contact from './Page/Contact/Contact'
import GelleryImage from './Page/Gallery/Image'
import Press from './Page/Gallery/Press'
import Complaint from './Page/Complaint/Complaint'
import StudentFeedback from './Page/Feedback/StudentFeedback'
import Feedback from './Page/Feedback/Feedback'
import AlumniFeedback from './Page/Feedback/AlumniFeedback'
import TeacherFeedback from './Page/Feedback/TeacherFeedback'
import ParentsFeedback from './Page/Feedback/ParenstFeedback'
import Notification from './Page/Notification/Notification'
import Video from './Page/Gallery/Video'
import Course from './Page/Academic/Course'
import Form from './Page/Feedback/Form'
import Topper from './Page/Academic/Topper'
import News from './Page/blog/News'
import Category from './Page/Gallery/Category'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<Layout />}>
      <Route path='' element={<Home />} />
      <Route path='student' element={<Student />} />
      <Route path='members' element={<Users />} />
      <Route path='signin' element={<Signin />} />
      <Route path='addmission' element={<Addmission />} />
      <Route path='academic' element={<Academic />} />
      <Route path='course' element={<Course />} />
      <Route path='facilites' element={<Facilites />} />
      <Route path='medicalFacilites' element={<MedicalFacilites />} />
      <Route path='department' element={<Department />} />
      <Route path='about' element={<About />} />
      <Route path='blog' element={<Blog />} />
      <Route path='contact' element={<Contact />} />
      <Route path='gallery' element={<GelleryImage />} />
      <Route path='pressrealse' element={<Press />} />
      <Route path='complaint' element={<Complaint />} />
      <Route path='feedback' element={<Feedback />} />
      <Route path='studentFeedback' element={<StudentFeedback />} />
      <Route path='alumniFeedback' element={<AlumniFeedback/>} />
      <Route path='teacherFeedback' element={<TeacherFeedback/>} />
      <Route path='parentsFeedback' element={<ParentsFeedback/>} />
      <Route path='notification' element={<Notification/>} />
      <Route path='form' element={<Form/>} />
      <Route path='video' element={<Video/>} />
      <Route path='topper' element={<Topper/>} />
      <Route path='news' element={<News/>} />
      <Route path='category' element={<Category/>} />
    </Route>
  )
)
function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}

export default App
